import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { ChevronRight } from 'lucide-react';

export default function StickyBook({ onBook }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll(); // check initial state
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className={`md:hidden fixed bottom-4 left-4 right-20 z-40 transition-all duration-300 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0 pointer-events-none'}`}>
      <div className="rounded-full p-[1.5px]" style={{background:'linear-gradient(90deg,#a855f7,#ec4899)'}}>
        <div className="rounded-full bg-[#0f0f16]/95 backdrop-blur px-2 py-1.5 flex items-center justify-between">
          <div className="pl-3">
            <div className="text-[11px] text-gray-400">Diamond AMC</div>
            <div className="text-white font-bold text-sm">₹4,999 <span className="text-gray-400 text-xs font-normal">/ 2 વર્ષ</span></div>
          </div>
          <Button onClick={() => onBook('diamond')} className="gradient-btn rounded-full h-10 px-4 text-sm font-semibold">બુક કરો <ChevronRight className="w-4 h-4 ml-1" /></Button>
        </div>
      </div>
    </div>
  );
}
